// removed by extract-text-webpack-plugin
module.exports = {"container":"TabBar__container___1C9rh","itemContainer":"TabBar__itemContainer___2eSpZ","itemText":"TabBar__itemText___1Qc-S","selected":"TabBar__selected___2A2Av"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/views/BaseElements/TabBar/TabBar.css
 ** module id = 716
 ** module chunks = 0
 **/